// extracted by mini-css-extract-plugin
export default {"pill":"ListingCardPill_pill__BZJ55","pillCompressed":"ListingCardPill_pillCompressed__ni094"};